import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import RichTextEditor from "@/components/RichTextEditor";

const PAGES = [
  { slug: "impressum", label: "Impressum" },
  { slug: "datenschutz", label: "Datenschutz" },
  { slug: "barrierefreiheit", label: "Barrierefreiheit" },
];

export default function AdminLegal() {
  const [active, setActive] = useState("impressum");
  const [page, setPage] = useState({ title: "", body: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get(`/legal/${active}`).then((r) => setPage({ title: r.data.title || "", body: r.data.body || "" })); }, [active]);

  async function save() {
    setSaving(true);
    try { await api.put(`/legal/${active}`, page); toast.success("Gespeichert"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  }

  return (
    <div data-testid="admin-legal">
      <h1 className="font-semibold text-3xl mb-1">Rechtliche Seiten</h1>
      <p className="text-sm text-neutral-500 mb-8">Impressum, Datenschutz und Barrierefreiheit pflegen.</p>

      <div className="flex gap-2 mb-6 border-b border-brand-line">
        {PAGES.map((p) => (
          <button
            key={p.slug}
            onClick={() => setActive(p.slug)}
            data-testid={`legal-tab-${p.slug}`}
            className={`px-4 py-2.5 text-sm border-b-2 -mb-px ${active === p.slug ? "border-[hsl(var(--brand-green-strong))] text-[hsl(var(--brand-green-dark))] font-medium" : "border-transparent text-neutral-500 hover:text-neutral-800"}`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="bg-white border border-brand-line p-8 space-y-4">
        <label className="block">
          <span className="block text-xs text-neutral-500 mb-1.5">Seitentitel</span>
          <input value={page.title} onChange={(e) => setPage({ ...page, title: e.target.value })} data-testid="legal-title" className="w-full border border-brand-line px-3 py-2.5 text-sm" />
        </label>
        <label className="block">
          <span className="block text-xs text-neutral-500 mb-1.5">Inhalt</span>
          <RichTextEditor
            value={page.body}
            onChange={(html) => setPage({ ...page, body: html })}
            minHeight={400}
            placeholder="Inhalt eingeben…"
            testid="legal-body"
          />
        </label>
        <div className="flex justify-end">
          <button onClick={save} disabled={saving} data-testid="legal-save" className="bg-[hsl(var(--brand-green-dark))] text-white px-6 py-2.5 text-sm hover:bg-[hsl(var(--brand-green-strong))] disabled:opacity-50">
            {saving ? "Speichern…" : "Speichern"}
          </button>
        </div>
      </div>
    </div>
  );
}
